import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useFetalDeathChartsDataContext } from './hooks/useFetalDeathChartsDataContext';

export const DeathsInRelationToChildbirth = () => {
    const { chartData } = useFetalDeathChartsDataContext();


    return (
        <SimpleBars
            title={'Mortes em relação ao parto'}
            horizontal={false}
            subtitles={chartData?.deathsInRelationToChildbirth?.map((item) => item.description)}
            values={chartData?.deathsInRelationToChildbirth?.map((item) => item.total  ||  0)}
            className='aligned-container'
        />
    );
};
